import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-new-features',
  templateUrl: './new-features.component.html',
})
export class NewFeaturesComponent implements OnInit {

  constructor(private el: ElementRef, private http: HttpClient, private dialogRef: MatDialogRef<NewFeaturesComponent>) { }
  features: any[];

  ngOnInit(): void {
    this.http.get('/assets/config/config.json').subscribe(config => {
      console.log(config);      
      this.features = config['features'];
    });
  }

  Close() {
    this.dialogRef.close();

  }
}
